var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 44,
    viewBox: "0 0 150 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 150,
    height: 44,
    transform: "translate(115.963 301)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_140",
    "data-name": "Mask Group 140",
    transform: "translate(-115.963 -301)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905",
    transform: "translate(121.704 307.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900",
    transform: "translate(30.974 2.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M783.492,447.3a5.9,5.9,0,0,1-4.762,1.974,5.262,5.262,0,0,1-4.175-1.614,6.864,6.864,0,0,1-1.418-4.669V432.01h3.807v10.935q0,3.228,2.679,3.227a3.763,3.763,0,0,0,3.744-1.99V432.01h3.807v16.951h-3.587Z",
    transform: "translate(-773.137 -424.897)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M866.786,400.4a2.02,2.02,0,0,1,.556-1.457,2.1,2.1,0,0,1,1.59-.58,2.128,2.128,0,0,1,1.6.58,2.005,2.005,0,0,1,.564,1.457,1.959,1.959,0,0,1-.564,1.434,2.143,2.143,0,0,1-1.6.572,2.116,2.116,0,0,1-1.59-.572A1.974,1.974,0,0,1,866.786,400.4Zm4.042,21.353h-3.807V404.8h3.807Z",
    transform: "translate(-848.864 -397.69)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M913.511,444.911a3.442,3.442,0,0,0,2.366-.83,2.837,2.837,0,0,0,1-2.052h3.587a5.589,5.589,0,0,1-.987,2.953,6.474,6.474,0,0,1-2.507,2.17,7.468,7.468,0,0,1-3.415.8,7.226,7.226,0,0,1-5.64-2.3,9.133,9.133,0,0,1-2.084-6.36V438.9a8.983,8.983,0,0,1,2.068-6.2,7.161,7.161,0,0,1,5.64-2.326,6.965,6.965,0,0,1,4.927,1.762,6.313,6.313,0,0,1,2,4.629H916.88a3.488,3.488,0,0,0-.995-2.4,3.2,3.2,0,0,0-2.374-.94,3.35,3.35,0,0,0-2.851,1.339,6.83,6.83,0,0,0-1.018,4.065v.611a6.948,6.948,0,0,0,.995,4.113A3.347,3.347,0,0,0,913.511,444.911Z",
    transform: "translate(-880.44 -423.574)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M1002.854,411.638l-1.692,1.739v5.53h-3.807V394.844h3.807v13.881l1.191-1.489,4.684-5.279h4.575l-6.3,7.065,6.972,9.886h-4.4Z",
    transform: "translate(-954.445 -394.844)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M1084.016,444.136l3.588-12.126h3.932l-5.875,16.951h-3.306l-5.922-16.951h3.948Z",
    transform: "translate(-1018.389 -424.897)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M1172.468,447.951a7.875,7.875,0,0,1-5.867-2.279,8.267,8.267,0,0,1-2.248-6.071v-.47a10.173,10.173,0,0,1,.979-4.535,7.454,7.454,0,0,1,2.75-3.11,7.27,7.27,0,0,1,3.948-1.112,6.653,6.653,0,0,1,5.35,2.209,9.342,9.342,0,0,1,1.888,6.251v1.535h-11.076a5.088,5.088,0,0,0,1.4,3.321,4.209,4.209,0,0,0,3.094,1.222,5.155,5.155,0,0,0,4.261-2.115l2.052,1.958a6.85,6.85,0,0,1-2.718,2.358A8.511,8.511,0,0,1,1172.468,447.951Zm-.454-14.523a3.206,3.206,0,0,0-2.53,1.1,5.685,5.685,0,0,0-1.23,3.055h7.254V437.3a4.629,4.629,0,0,0-1.018-2.891A3.182,3.182,0,0,0,1172.014,433.428Z",
    transform: "translate(-1089.483 -423.574)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M1262.434,447.951a7.876,7.876,0,0,1-5.867-2.279,8.268,8.268,0,0,1-2.248-6.071v-.47a10.174,10.174,0,0,1,.979-4.535,7.455,7.455,0,0,1,2.749-3.11,7.27,7.27,0,0,1,3.948-1.112,6.652,6.652,0,0,1,5.35,2.209,9.341,9.341,0,0,1,1.888,6.251v1.535h-11.076a5.089,5.089,0,0,0,1.4,3.321,4.209,4.209,0,0,0,3.094,1.222,5.155,5.155,0,0,0,4.261-2.115l2.052,1.958a6.853,6.853,0,0,1-2.718,2.358A8.512,8.512,0,0,1,1262.434,447.951Zm-.454-14.523a3.206,3.206,0,0,0-2.53,1.1,5.682,5.682,0,0,0-1.23,3.055h7.253V437.3a4.629,4.629,0,0,0-1.018-2.891A3.182,3.182,0,0,0,1261.98,433.428Z",
    transform: "translate(-1162.232 -423.574)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903",
    transform: "translate(5.73 9.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M645.054,435.991a1.46,1.46,0,0,1-.82-.251l-2.36-1.6a1.462,1.462,0,1,1,1.639-2.422l1.542,1.044,1.521-1.026a1.463,1.463,0,0,1,1.635,2.426l-2.341,1.578A1.461,1.461,0,0,1,645.054,435.991Z",
    transform: "translate(-641.231 -431.468)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902",
    transform: "translate(8.854 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M691.321,435.992a1.461,1.461,0,0,1-.82-.251l-2.36-1.6a1.463,1.463,0,1,1,1.639-2.423l1.542,1.044,1.521-1.026a1.463,1.463,0,0,1,1.635,2.425l-2.341,1.578A1.461,1.461,0,0,1,691.321,435.992Z",
    transform: "translate(-687.498 -431.47)",
    fill: "#0a64f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M629.518,402.346l-2.388,2.388,2.436,2.435a10.608,10.608,0,1,1,4.091-3.225l-.247.32,2.4,2.4.322-.4a14.021,14.021,0,1,0-4.052,3.417l4.08,4.081,2.388-2.388Z",
    transform: "translate(-611.29 -383.527)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1070",
    "data-name": "Rectangle 1070",
    width: 3.377,
    height: 0.997,
    transform: "translate(25.448 30.815) rotate(-44.995)",
    fill: "#0a64f9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 1.437,
    cy: 1.437,
    r: 1.437,
    transform: "translate(26.136 22.675)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 0.849,
    cy: 0.849,
    r: 0.849,
    transform: "translate(27.9 25.942)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 0.653,
    cy: 0.653,
    r: 0.653,
    transform: "translate(28.684 21.434)",
    fill: "#0a64f9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLogo);
export default __webpack_public_path__ + "static/media/imageLogo.be43e8896b9e7373c1124e3e5ab14d35.svg";
export { ForwardRef as ReactComponent };